import { FC, memo } from 'react';
import { useTheme } from 'styled-components';
import { SVGIconProps } from 'types';

const SvgTextbookIcon: FC<SVGIconProps> = ({ color: propsColor, ...props }) => {
  const { colors } = useTheme();
  const color = propsColor || colors.neutrals[1];
  return (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {/* A closed book with a spine and a bookmark. One path, even-odd, so the sidebar can
          recolour the whole glyph for its hover and selected states like every other icon. */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2.667h16A2.667 2.667 0 0 1 26.667 5.333v21.334A2.667 2.667 0 0 1 24 29.333H8A2.667 2.667 0 0 1 5.333 26.667V5.333A2.667 2.667 0 0 1 8 2.667Zm1.333 4v18.666h1.334V6.667H9.333Zm9.334 0v9.333l2-2 2 2V6.667h-4Z"
        fill={color}
      />
    </svg>
  );
};

const Memo = memo(SvgTextbookIcon);
export default Memo;
